import React from 'react';

const ScreenContext = React.createContext({});

export const ScreenContextProvider = ScreenContext.Provider;
export const ScreenContextConsumer = ScreenContext.Consumer;

export default ScreenContext;
